<template>
  <div
    class="structure df both-side"
    v-for="item in props.staffList"
    :key="item.id"
  >
    <div
      class="df vertical"
      @click="handleSelectUser(item)"
      :class="selectId === item.id ? 'active user' : ' user'"
      v-if="userId !== item.id"
    >
      <div class="icon df vertical df-center">
        <UserOutlined />
      </div>
      {{ item.nickName }}
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { UserOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";

export default defineComponent({
  components: { UserOutlined },
  props: {
    staffList: Array,
  },
  setup(props, context) {
    const selectId = ref(null);

    const userId = useStore().state.user.user.id;

    const handleSelectUser = (item) => {
      selectId.value = item.id;
      context.emit("handleSelectUser", item);
    };

    watch(
      () => props.staffList,
      (val) => {
        if (val) {
            selectId.value = null;
            // context.emit("handleSelectUser", null);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      selectId,
      userId,
      handleSelectUser,
    };
  },
});
</script>

<style lang="less" scoped>
.structure {
  font-size: 17px;
  width: 260px;
  .user {
    width: 260px;
    padding: 5px 10px;
    border-radius: 5px;
  }
  cursor: pointer;
  .active {
    background: #daebe7;
  }
  .icon {
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
    margin-right: 10px;
    border-radius: 7px;
  }
}
</style>
